import { useSession } from 'next-auth/react'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'

export const useNavBar = () => {
  const { data, status } = useSession()
  const router = useRouter()
  const pathname = usePathname() // current path

  const isLogin =
    status === 'authenticated' && Boolean(data?.access_token)

  const [mounted, setMounted] = useState(false)
  const [active, setActive] = useState('')
  const desktopMenuRef = useRef(null)
  const scrollTimeoutRef = useRef(null)

  const handleClick = (section) => {
    if (pathname !== '/') {
      router.push(`/#${section}`) // navigate first
    } else {
      const el = document.getElementById(section)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  // Smooth scroll function
  const scrollToSection = (sectionId) => {
    if (scrollTimeoutRef.current) clearTimeout(scrollTimeoutRef.current)

    scrollTimeoutRef.current = setTimeout(() => {
      if (pathname !== '/') {
        router.push(`/#${sectionId}`)
      } else {
        const element = document.getElementById(sectionId)
        if (element) {
          const offsetTop =
            element.getBoundingClientRect().top + window.pageYOffset - 100
          window.scrollTo({ top: offsetTop, behavior: 'smooth' })
        }
      }
    }, 100)
  }

  // Handle outside click for desktop menu
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        desktopMenuRef.current &&
        !desktopMenuRef.current.contains(e.target)
      ) {
        setActive('')
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [])

  useEffect(() => {
    if (status !== 'loading') {
      setMounted(true)
    }
  }, [status])

  return {
    router,
    pathname,
    isLogin,
    mounted,
    setMounted,
    active,
    setActive,
    desktopMenuRef,
    scrollTimeoutRef,
    handleClick,
    scrollToSection,
  }
}
